import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(() => ({
  divBox: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
}));
